<template>
  <div class="container flex" style="padding-bottom: 20px;margin-top: 15px;">
    <div>
      <left></left>
    </div>
    <div class="right">
      <threecategory @initData="initData"></threecategory>
      <div class="live topprograss" style="background-color: #fff;">
      	<div class="flex">
      		<div class="left flex1">
      			<div class="top">
      				<span style="margin-right: 15px;width: 70PX;">做题进度</span>
      				<div class="prograss">
      					<span class="rato"  :style="'width: '+data.alreadyQuestionCount/data.totalQuestionCount*100+'%'"></span>
      				</div>
      				<span class="done">已做：{{data.alreadyQuestionCount}}</span>/ 总数：{{data.totalQuestionCount}}
      			</div>
      			<div class="bottom" style="margin-top: 30px;">
      				<span style="margin-right: 15px;width: 70PX;">正确率</span>
      				<div class="prograss">
      					<span class="rato"  :style="'width: '+data.answerRatio+'%'"></span>
      				</div>
      				正确率：
      				<span class="done">{{data.answerRatio}}</span>
      			</div>
      		</div>
      	<!-- 	<div class="btn">
      			开始练习
      		</div> -->
      	</div>
      </div>
      <div class="live flex1" style="background-color: #fff;margin-top: 20px;">
      	<div class="title">
      		历年真题
      	</div>
      	<div class="lists flex algin-center" v-for="item,index in list">
      		<div class="left flex1">
      			<div class="" style="font-weight: bold;">
      				{{item.title}}
      			</div>
      			<div class="" style="font-weight: normal;margin-top: 10px;font-size: 14px;text-indent: 20px;">
      				{{item.peopleCount}}做过          共{{item.totalQuestionsCount}}道
      			</div>
      		</div>
      		<div class="btn" @click="handleToTest(item.testQuestionsId,item.totalQuestionsCount,item.questionsStatus)" v-if="isbuy">开始做题</div>
          <div class="btn" @click="handleToBuy()" v-else>购买</div>
      	</div>
      </div>
    </div>
  </div>
</template>

<script>
  import threecategory from './threecategory.vue'
  import left from './left.vue'
  import bus from '../assets/utils/eventBus.js';
  export default {
    name: 'Footer',
    components:{
      left,
      threecategory
    },
    data () {
      return {
          data:'',
          pageNo:1,
          pageSize:100,
          questionsStatus:1,
          list:[],
          isbuy:this.$store.state.isbuy
      }
    },
    methods:{
      getTestData(testQuestionsId,questionsStatus){ //获取数据
      var url=this.$common.testPaper_testPaperQuestionList;
      	if(this.questionsStatus>2){

      		url=this.$common.testPaper_selectTestQuestionListByPageSize
      	}
        let data={
          pageNo:1,
          pageSize:1000,
          testQuestionsId:testQuestionsId
        };
        this.$axios.get(url,{params:data}).then((res)=>{

        })
      },
      handleToBuy(){
        this.$router.push('buy')
      },
      getData(){
        let data={
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          questionsStatus:this.questionsStatus,
        };
        this.$axios.get(this.$common.testPaper_testPaperList,{params:data}).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data.list;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleToTest(testQuestionsId,totalQuestionsCount,questionsStatus){
        if(totalQuestionsCount==0){
          alert('上题中');
          return;
        }
        this.getTestData(testQuestionsId,questionsStatus)
        this.$router.push('examsdetail?questionsStatus='+this.questionsStatus+'&testQuestionsId='+testQuestionsId)
      },
      getDatas(){
        this.$axios.get(this.$common.testPaper_selectQuestionsCountByAccountId+'?childQuestionStatus='+this.questionsStatus).then((res)=>{
              if(res.data.code==1){
                  this.data=res.data.data;

              }
              else {
                alert(res.data.msg)
              }
        })
      },
      initData(){
          this.getData();
          this.getDatas();
      }
    },
    created(){
      this.getData();
      this.getDatas();
    },
    mounted() {
      bus.$on('bugTag',(res)=>{
          this.isbuy=res;
      })
    }
  }
</script>

<style scoped>
  .live .lists {
  	line-height: inherit;
  	text-indent: 25px;
  	padding: 15px;
  	border-bottom: 1px solid #ccc;

  }
  .btn {
  	color: #4fa7ff;
  	    border: 1px solid #4fa7ff;
  	    text-align: center;
  	    display: inline-block;
  	    display: -webkit-box;
  	    display: -ms-flexbox;
  	    display: flex;
  	    -webkit-box-pack: center;
  	    -ms-flex-pack: center;
  	    justify-content: center;
  	    text-indent: 0;
  	    padding: 0 30px;
  	    height: 40px !important;
  	    -webkit-box-align: center;
  	    -ms-flex-align: center;
  	    align-items: center;
  	    margin-right: 15px;
  	    cursor: pointer;
        font-weight: normal;
  }
  .right {
    flex:1;
    overflow: hidden;
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/history.vue